import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { LinkButton } from "~/common/components/Link";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import ShareWishlistViaEmailPopup from "~/Wishlist/modal/ShareWishlistViaEmailPopup/ShareWishlistViaEmailPopup";
import { type WishlistModel } from "~/Wishlist/model";
import { useTranslation } from "react-i18next";

interface Props {
  wishlist: WishlistModel;
}
export const ShareWishlistButton = ({ wishlist }: Props) => {
  const { t } = useTranslation();
  const [shareWishlistModal, openShareWishlist] = useShareWishlistViaEmailPopup(wishlist?.id, wishlist?.name);

  return (
    <>
      <LinkButton
        data-test-id={"btn-share-wishlist-via-email"}
        iconBefore={<Icon type={IconType.Share} />}
        onClick={openShareWishlist}
      >
        {t("page.wishlist.action.share")}
      </LinkButton>
      {shareWishlistModal}
    </>
  );
};

const useShareWishlistViaEmailPopup = (
  selectedWishlistId: string | undefined,
  selectedWishlistName: string | undefined
) => {
  const { val: isModalOpen, setTrue, setFalse } = useBooleanState(false);

  const modal = isModalOpen && selectedWishlistName && (
    <ShareWishlistViaEmailPopup
      onClose={setFalse}
      selectedWishlistName={selectedWishlistName}
      selectedWishlistId={selectedWishlistId}
      onSuccess={setFalse}
    />
  );
  return [modal, setTrue] as const;
};
